<h1>{{'global.name.configurator' | translate}}<br>Smart Designer</h1>
@if (newsNotifications && newsNotifications.length > 0) {
  <h2>{{'login.label.news' | translate}}</h2>
}

<div class="carousel">
  <div class="carousel-overlay"></div>
  <div #carouselCardsWrapper class="carousel-cards-wrapper">
    @for (cardContent of newsNotifications; track cardContent; let i = $index) {
      <div #carouselCard
        class="carousel-card"
        [innerHTML]="getNewsContent(cardContent)"
        (click)="focusNewsCard(i)">
      </div>
    }
    @if (!newsNotifications || newsNotifications.length == 0) {
      <div
        #carouselCard
        class="carousel-card"
        [innerHTML]="'login.news.fallback' | translate">
      </div>
    }
  </div>
</div>

<div class="carousel-progress d-flex gap-3">
  @for (_ of newsNotifications; track _; let i = $index) {
    <div class="progress-selector"
      (click)="focusNewsCard(i)"
      [class.active]="selectedCard == i"
    ></div>
  }
</div>

@if (newsNotifications && newsNotifications.length > 0) {
  <div
    class="d-flex jusify-content-space-between align-items-center gap-3">
    <button (click)="focusNewsCard(selectedCard - 1)" class="btn btn-secondary">
      <app-svg-icon type="caret-left"/>
    </button>
    <span>{{newsNotifications?.length}} {{'login.label.new_features' | translate}}</span>
    <button (click)="focusNewsCard(selectedCard + 1)" class="btn btn-secondary">
      <app-svg-icon type="caret-right"/>
    </button>
  </div>
}
